import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltRecorderPlayerFullScreenButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-full-screen-button-wireframe", __assign({}, transformedProps), children));
};
export default VeltRecorderPlayerFullScreenButtonWireframe;
